import Axios from "@/plugins/Axios";

export class PlanosAnuaisInfantil {
  async planoBimestral(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais-infantil/plano-bimestral/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-bimestrais-infantil/criar-plano-bimestral`, {
      plano,
    });
    return response.data;
  }

  async disciplinas() {
    const response = await Axios().get(`planos-anuais-infantil/disciplinas`);
    return response;
  }

  async turmasInfantil() {
    const response = await Axios().get(`planos-anuais-infantil/turmas-infantil`);
    return response;
  }

  async indexInfantil(pageNumber, query, turma, disciplina) {
    const planos = await Axios().get(
      `planos-anuais-infantil/planos-anuais-infantil?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}`
    );
    return planos.data;
  }

  async pdfInfantil(planoId) {
    const base64 = await Axios()
      .get(`planos-bimestrais-infantil/${planoId}/relatorio`, {
        responseType: "arraybuffer",
      })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async showInfantil(planoId) {
    const response = await Axios().get(`planos-bimestrais-infantil/${planoId}/visualizar`);
    return response;
  }
}

export default new PlanosAnuaisInfantil();
